export const ignoreIfPreview = (fn: any) => {
  if (
    (window as any).mode === 'preview' ||
    (window as any).mode === 'adminRegistration'
  ) {
    return;
  }

  return fn();
};

export const isPreviewMode = () => {
  try {
    return (
      (window as any).mode === 'preview' ||
      (window as any).mode === 'adminRegistration'
    );
  } catch (error) {
    return false;
  }
};

export const isAdminRegistrationMode = () => {
  try {
    return (window as any).mode === 'adminRegistration';
  } catch (error) {
    return false;
  }
};

/** Email passed from BD when embedding CA for admin-led registration */
export const getAdminRegistrationEmail = (): string | undefined => {
  try {
    if ((window as any).mode !== 'adminRegistration') return undefined;
    const email = (window as any).adminRegistrationData?.email;
    return typeof email === 'string' && email.trim() ? email.trim() : undefined;
  } catch {
    return undefined;
  }
};

export const ADMIN_REGISTRATION_READY_EVENT = 'adminRegistrationReady';
